import {
  groupBy,
  isFinite,
  keyBy,
  maxBy,
  mean,
  meanBy,
  round,
  upperFirst
} from 'lodash'
import { format } from 'date-fns'
import calculateMkt from './mktHelper'
import { DevicePropertySorterMap } from '../constants/devicepropertySorterMap'
import { naturalCompare } from './naturalSortHelper'
import * as assetTypeHelper from "./assetTypeHelper";

export const prepareGroupedAssetPropertyTable  = (data)=>{
  const _tableData = [];
  if (data && Array.isArray(data)) {
    if (data.length > 0) {
      const _tempData  = groupBy(data, (item) => item.propertyGroup?.name);
      Object.keys(_tempData).forEach((keyName) => {
        const _rows = _tempData[keyName];
        let min,
          max,
          last,
          avg,
          mkt,
          stdDev,
          optimalPercentage,
          optimalBelowLowPercentage,
          optimalAboveHighPercentage,
          incidentBelowLowPercentage,
          incidentAboveHighPercentage,
          completePercentage;

        const completePercentageArray = [];
        const optimalPercentageArray = [];
        const optimalBelowLowPercentageArray = [];
        const optimalAboveHighPercentageArray = [];
        const incidentBelowLowPercentageArray = [];
        const incidentAboveHighPercentageArray = [];
        const minArray = [];
        const maxArray = [];
        const avgArray = [];
        const lastValueArray = [];
        const mktValueArray = [];
        const stdDevArray = [];

        _rows.forEach((rowItem) => {
          if (!rowItem.outOfServiceAt) {
            if (isFinite(rowItem.min)) {
              minArray.push(rowItem.min);
            }
            if (isFinite(rowItem.max)) {
              maxArray.push(rowItem.max);
            }
            if (isFinite(rowItem.avg)) {
              avgArray.push(rowItem.avg);
            }
            if (isFinite(rowItem.last)) {
              lastValueArray.push(rowItem.last);
            }
            if (isFinite(rowItem.completePercentage)) {
              completePercentageArray.push(rowItem.completePercentage);
            }
            if (isFinite(rowItem.optimalPercentage)) {
              optimalPercentageArray.push(rowItem.optimalPercentage);
            }
            if (isFinite(rowItem.optimalBelowLowPercentage)) {
              optimalBelowLowPercentageArray.push(rowItem.optimalBelowLowPercentage);
            }
            if (isFinite(rowItem.optimalAboveHighPercentage)) {
              optimalAboveHighPercentageArray.push(rowItem.optimalAboveHighPercentage);
            }
            if (isFinite(rowItem.incidentBelowLowPercentage)) {
              incidentBelowLowPercentageArray.push(rowItem.incidentBelowLowPercentage);
            }
            if (isFinite(rowItem.incidentAboveHighPercentage)) {
              incidentAboveHighPercentageArray.push(rowItem.incidentAboveHighPercentage);
            }
            if (isFinite(rowItem.mkt)) {
              mktValueArray.push(rowItem.mkt);
            }
            if (isFinite(rowItem.stdDev)) {
              stdDevArray.push(rowItem.stdDev);
            }
          }
        })
        if (minArray.length > 0) {
          min = Math.min(...minArray)
        }
        if (maxArray.length > 0) {
          max = Math.max(...maxArray)
        }
        if (avgArray.length > 0) {
          avg = round(mean(avgArray), 1)
        }
        if (lastValueArray.length > 0) {
          last = round(mean(lastValueArray), 1)
        }
        if (completePercentageArray.length > 0) {
          completePercentage = round(mean(completePercentageArray), 1)
        }
        if (optimalPercentageArray.length > 0) {
          optimalPercentage = round(mean(optimalPercentageArray), 1)
        }
        if (optimalBelowLowPercentageArray.length > 0) {
          optimalBelowLowPercentage = round(
            mean(optimalBelowLowPercentageArray),
            1
          )
        }
        if (optimalAboveHighPercentageArray.length > 0) {
          optimalAboveHighPercentage = round(
            mean(optimalAboveHighPercentageArray),
            1
          )
        }
        if (incidentBelowLowPercentageArray.length > 0) {
          incidentBelowLowPercentage = round(
            mean(incidentBelowLowPercentageArray),
            1
          )
        }
        if (incidentAboveHighPercentageArray.length > 0) {
          incidentAboveHighPercentage = round(
            mean(incidentAboveHighPercentageArray),
            1
          )
        }
        if (stdDevArray.length > 0) {
          stdDev = round(mean(stdDevArray), 1)
        }
        mkt = calculateMkt(mktValueArray);
        const newRow = {
          propertyGroup: {
            name: keyName,
          },
          unit: _rows.length > 0 ? _rows[0].unit : '',
          property: _rows.length > 0 ? _rows[0].property : '',
          max,
          min,
          avg,
          last,
          mkt,
          stdDev,
          completePercentage,
          optimalPercentage,
          optimalBelowLowPercentage,
          optimalAboveHighPercentage,
          incidentBelowLowPercentage,
          incidentAboveHighPercentage,
          nodes: _rows,
        }
        _tableData.push(newRow)
      })
    }
  }
  return _tableData;
}


export const prepareAssetLastPropertyInfo = (original)=>{
  let _isAllOffline = false;
  let _propertySummaries = [];
  if (original) {
    let _devicePropertyLastStats = original?.devicePropertyLastStats ? [...original?.devicePropertyLastStats] : undefined
    const devicePropertySummaryLastValueOnly = original.devicePropertySummaryLastValueOnly && Array.isArray(original.devicePropertySummaryLastValueOnly) ? original.devicePropertySummaryLastValueOnly.map((item) => {
      const newItem = { ...item }
      newItem.lastTime = parseInt(newItem.lastTime)
      return newItem
    }) : []
    let _propertySummaryGrouped = groupBy(devicePropertySummaryLastValueOnly, 'propertyGroupName')
    Object.keys(_propertySummaryGrouped).forEach((keyName) => {
      const type = _propertySummaryGrouped[keyName][0].propertyGroupType?.toString()?.toLowerCase();
      _propertySummaries.push({
        propertyGroupName: keyName,
        value: round(meanBy(_propertySummaryGrouped[keyName], 'last'), 1),
        unit: _propertySummaryGrouped[keyName][0].unit,
        time: maxBy(_propertySummaryGrouped[keyName], 'lastTime').lastTime,
        propertyGroupType: _propertySummaryGrouped[keyName][0].propertyGroupType,
        sortIndex: type && DevicePropertySorterMap[type] ? DevicePropertySorterMap[type] : 20,
        status: 'normal'
      })
    })
    const _propertySummariesMap = keyBy(_propertySummaries, 'propertyGroupName')
    _propertySummaries = [..._propertySummaries].sort(
      (a, b) =>
        (a.sortIndex ?? 20) - (b.sortIndex ?? 20) ||
        naturalCompare(a.propertyGroupName, b.propertyGroupName)
    )
    if (_devicePropertyLastStats && Array.isArray(_devicePropertyLastStats)) {
      _isAllOffline = _devicePropertyLastStats.every(item => item.status === 'offline')
      if (assetTypeHelper.isVehicleType(original.type)) {
        if (original.atDepotSince) {
          _propertySummaries.push({
            isShowInReport: false,
            name: 'vehicleAtDepot',
            propertyGroupName:  original.lastDepot?.name ? `Vehicle at depot ${original.lastDepot?.name}`: 'Vehicle at depot',
            propertyGroupType: 'vehicleAtDepot',
            status: 'normal',
            hideValue: true,
            time: parseInt(original.atDepotSince) * 1000,
            unit: '',
            value: true,
          })
        } else {
          _propertySummaries.push({
            isShowInReport: false,
            name: 'vehicleAtTrip',
            propertyGroupName: 'Vehicle at trip',
            propertyGroupType: 'vehicleAtTrip',
            lastLocation: original.lastLocation,
            status: 'normal',
            hideValue: true,
            time: parseInt(original.lastReportedAt),
            unit: '',
            value: false
          })
        }
      }
      _devicePropertyLastStats.forEach(item => {
        if (_propertySummariesMap[item.propertyGroupName]) {
          _propertySummariesMap[item.propertyGroupName].status = item.status
        }
      })
    }
  }

  return {_isAllOffline, _propertySummaries};
}

export const parseDailyDevicePropertySummary = (data = []) => {
  if (!data || !data.length) {
    return { rows: [], properties: [] };
  }

  const distinctPropertiesMap = new Map();
  data.forEach((item) => {
    const propKey = `${item.deviceName} - ${item.name}`;
    if (!distinctPropertiesMap.has(propKey)) {
      distinctPropertiesMap.set(propKey, {
        key: propKey,
        label: `${item.deviceName} - ${upperFirst(item.name)}`,
        deviceName: item.deviceName,
        propertyName: item.name,
        unit: item.unit || '',
      });
    }
  });

  const properties = Array.from(distinctPropertiesMap.values());
  const groupedByTime = groupBy(data, 'time');
  const sortedTimes = Object.keys(groupedByTime).sort((a, b) => Number(a) - Number(b));

  const rows = sortedTimes.map((timeKey) => {
    const timeNum = Number(timeKey);
    const date = new Date(timeNum);
    const row = {
      time: timeNum,
      formattedDate: format(date, 'dd/MM/yyyy'),
      date,
    };

    const itemsForTime = groupedByTime[timeKey];
    itemsForTime.forEach((item) => {
      const propKey = `${item.deviceName} - ${item.name}`;
      row[`${propKey}_min`] = item.min;
      row[`${propKey}_max`] = item.max;
      row[`${propKey}_avg`] = item.avg;
      row[`${propKey}_unit`] = item.unit || '';
    });

    return row;
  });

  return { rows, properties };
};

